export default "__VITE_ASSET__GTZvKeNAAzFegik$lyJ$CQ__"